import { userKey } from 'queryKeys';

const SUBSCRIPTIONS = 'subscriptions';

export const subscriptions = () => [SUBSCRIPTIONS];

const sQuery = userKey.query(SUBSCRIPTIONS);

export const model = sQuery.exact();

export const mutations = sQuery.mutations();

export const remove = mutations.delete();
export const update = mutations.update();
export const create = mutations.create();
